import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { FormatPrice } from 'utils/format';

const t = {
  bidsUnder: 'Accepting bids under',
};

const MaxCostChanges = ({ className, changes }) => {
  if (!changes) {
    return null;
  }

  return (
    <div className={className} data-testid="max-cost-changes">
      {changes.map(
        ({ active_from: activeFrom, max_cost: maxCost, currently_active: currentlyActive }) => {
          const time = moment(activeFrom).format('YYYY-MM-DD HH:mm');
          return (
            <div className="item">
              <span className="item__time">{time}</span>
              {`${currentlyActive ? 'Now - ' : ''}${t.bidsUnder} `}
              <FormatPrice value={maxCost} currency="EUR" />
            </div>
          );
        }
      )}
    </div>
  );
};

MaxCostChanges.propTypes = {
  className: PropTypes.string,
  changes: PropTypes.arrayOf(
    PropTypes.shape({
      active_from: PropTypes.string,
      max_cost: PropTypes.string,
    })
  ),
};

export default MaxCostChanges;
